import { DIST_PRODUCT } from '@/enums/dist-products'

export const isMeinBuero = () => {
  return ENV.product === DIST_PRODUCT.meinbuero
}
